var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPump(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 42.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.38,0A1.38,1.38,0,0,0,0,1.38V14a1.38,1.38,0,0,0,2.76,0V1.38A1.38,1.38,0,0,0,1.38,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.62,27.22a1.38,1.38,0,0,0-1.38,1.38V41.18a1.38,1.38,0,1,0,2.76,0V28.6A1.38,1.38,0,0,0,70.62,27.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.12,27.22H56.29A21.27,21.27,0,0,0,35.85,0H12.34A5.34,5.34,0,0,0,7,5.34V10a5.34,5.34,0,0,0,5.34,5.34h3.08A21.28,21.28,0,0,0,35.85,42.57H59.12a5.34,5.34,0,0,0,5.33-5.34V32.55A5.33,5.33,0,0,0,59.12,27.22ZM12.34,12.58A2.59,2.59,0,0,1,9.76,10V5.34a2.59,2.59,0,0,1,2.58-2.58h13a21.4,21.4,0,0,0-8.94,9.82ZM36.22,39.8h-.64a18.47,18.47,0,1,1,.64,0Zm25.47-2.58a2.58,2.58,0,0,1-2.57,2.58H46.34A21.48,21.48,0,0,0,55.27,30h3.85a2.58,2.58,0,0,1,2.57,2.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.85,19.81a1.77,1.77,0,1,0,1.77,1.77A1.77,1.77,0,0,0,35.85,19.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.36,20.88l-1.24,0h0l-1.38,0h0L45,21h0l-1.56,0-2,0a5.62,5.62,0,0,0-1.33-3.1L46,12S41,6.35,35.26,8v.34h0V9h0l0,1.43,0,1.64h0l0,1.39h0l0,2.47a5.59,5.59,0,0,0-3,1.2l-5.87-5.88s-5.68,5-4.08,10.78h1.2l1.59,0,1.51,0h0l1.38,0h0l2.14,0a5.66,5.66,0,0,0,1.26,3.23l-5.59,5.4c2.91,5.18,10.5,4.74,10.5,4.74V27.2a5.57,5.57,0,0,0,3.11-1.32l5.78,5.78S51,26.61,49.36,20.88ZM35.85,24.46a2.88,2.88,0,1,1,2.88-2.88A2.88,2.88,0,0,1,35.85,24.46Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPump);
export default __webpack_public_path__ + "static/media/Pump.23bd8ab4.svg";
export { ForwardRef as ReactComponent };